// Loads GA4 + Meta Pixel scripts on demand, based on env vars.
// No-op when the vars are missing so preview/dev stay quiet.
// Reads:
//   REACT_APP_GA_MEASUREMENT_ID   → GA4 (e.g. "G-XXXXXXXXXX")
//   REACT_APP_META_PIXEL_ID       → Meta Pixel (e.g. "1234567890123456")
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

let bootstrapped = false;

const injectScript = (src, attrs = {}) => {
    const s = document.createElement("script");
    s.async = true;
    s.src = src;
    Object.keys(attrs).forEach((k) => s.setAttribute(k, attrs[k]));
    document.head.appendChild(s);
    return s;
};

const bootstrapGA = (id) => {
    injectScript(`https://www.googletagmanager.com/gtag/js?id=${id}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", id, { send_page_view: false });
};

const bootstrapMeta = (pixelId) => {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
        t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)
    }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq("init", pixelId);
    // PageView fires per-route from usePageView below.
};

const bootstrap = () => {
    if (bootstrapped) return;
    const ga = process.env.REACT_APP_GA_MEASUREMENT_ID;
    const meta = process.env.REACT_APP_META_PIXEL_ID;
    if (ga) bootstrapGA(ga);
    if (meta) bootstrapMeta(meta);
    bootstrapped = true;
};

/**
 * Fires page_view / PageView on every route change (SPA-friendly).
 * Silently does nothing when no pixel is configured.
 */
export const usePageView = () => {
    const loc = useLocation();
    useEffect(() => {
        bootstrap();
        const ga = process.env.REACT_APP_GA_MEASUREMENT_ID;
        if (ga && window.gtag) {
            window.gtag("event", "page_view", {
                page_path: loc.pathname + loc.search,
                page_location: window.location.href,
                page_title: document.title,
            });
        }
        if (window.fbq) window.fbq("track", "PageView");
    }, [loc.pathname, loc.search]);
};

/**
 * Domain-specific conversion helpers — call these where they matter.
 * They no-op automatically when analytics isn't configured.
 */
export const trackAddToCart = (item, quantity = 1) => {
    if (window.gtag) {
        window.gtag("event", "add_to_cart", {
            currency: "INR",
            value: (item?.unit_price || 0) * quantity,
            items: [{ item_id: item?.item_id, item_name: item?.item_name, price: item?.unit_price, quantity }],
        });
    }
    if (window.fbq) window.fbq("track", "AddToCart", { value: (item?.unit_price || 0) * quantity, currency: "INR" });
};

export const trackViewItem = (item) => {
    if (window.gtag) {
        window.gtag("event", "view_item", {
            currency: "INR",
            value: item?.rental_price || 0,
            items: [{ item_id: item?.id, item_name: item?.name, price: item?.rental_price }],
        });
    }
    if (window.fbq) window.fbq("track", "ViewContent", { value: item?.rental_price || 0, currency: "INR", content_ids: [item?.id], content_type: "product" });
};

export const trackLead = (bookingId, total) => {
    if (window.gtag) window.gtag("event", "generate_lead", { currency: "INR", value: total || 0, transaction_id: bookingId });
    if (window.fbq) window.fbq("track", "Lead", { value: total || 0, currency: "INR" });
};
